import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeClaimTypeList } from './normalize';

export const fetchClaimTypeList = createProvider(api.fetchClaimTypeList)
  .andThen((res) => normalizeClaimTypeList(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch claim type list aborted');
    } else {
      console.error('Fetch claim type list was failed:', error);
    }
    throw error;
  });
